import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const LyricsShadowOpacityListItem = (props) => {
    const { shadowSettingsOpacity, updateLyricsStyle, maxDropShadowOpacity } = props;

    const onShadowOpacityChange = (value) => {
        previewHistoryBatch.start();

        updateLyricsStyle({
            shadowSettings: { opacity: value }
        });
    };

    return (
        <SliderListItem
            title='Opacity'
            value={shadowSettingsOpacity}
            displayMultiplier={100}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowOpacityChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { shadowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const shadowSettingsOpacity = shadowSettings ? shadowSettings.opacity : 0;
    const { maxDropShadowOpacity } = state.create.maxValues;

    return {
        shadowSettingsOpacity,
        maxDropShadowOpacity
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsShadowOpacityListItem);
